import RequiredValidator from "@/validators/RequiredValidator";

export default class TranslatedValueRules {

	public static readonly deRules = [
		(new RequiredValidator('locale.de-CH')).validationRule(),
	];

}
